import validate from "/usr/src/app/content/n3-redirections-spa-5a91363b-d3a0-4c3c-bc72-d469ea980387/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-spa-5a91363b-d3a0-4c3c-bc72-d469ea980387/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}